import { useEffect } from "react"

export default function Lp() {
    useEffect(() =>{
        window.location.href = "https://usa.ketobalanced.com";
    },[])
  return (
    <div className="bg-custombgColor w-screen h-screen flex justify-center items-center">Loading...</div>
  )
}